import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';

export const Slide = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 30px;
  min-height: 0;
  width: 100%;
`;

export const Hero = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 30px;
  justify-content: center;
  min-height: 0;
  text-align: center;
`;

export const BellIcon = styled.div`
  color: ${colours.neutral[300]};
  display: flex;

  svg {
    height: 132px;
    width: 132px;
  }

  /* Scale the stroke with the icon like the Figma bell, instead of the
     global fixed 2px stroke for 24px icons. */
  svg path {
    stroke: currentColor;
    vector-effect: none;
  }
`;

export const TextSection = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const Header = styled(Text.H4)`
  text-align: center;
`;

export const Description = styled(Text.P2)`
  text-align: center;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 10px;
  width: 100%;
`;
